import { History } from "history";
import { memoize } from "lodash";
import { observable } from "mobx";
import { apiCallLogAdminSubTabAccess } from "../../../api/core-api/api-call-log-admin-sub-tab-access";
import { TCorePage } from "../../../Types";
import getCorePopUpStore from "../core-popup-store";

import getCoreTimingStore from "../core-timing-store";
import getRootStore from "../root-store";

class CoreHistoryStore {
  history = observable.box<History>();
  pageName = observable.box<TCorePage>("");
  pageSubName = observable.box<string>("");
  setPageName = async (page: TCorePage, pageSubName: string) => {
    if (page.indexOf("AUDITOR") > -1 || page.indexOf("SUPERVISOR") > -1) {
      getRootStore().getAllAdmins();
    }

    const oldPage = this.pageName.get();
    getCoreTimingStore().getPageDates(oldPage, page);
    this.pageName.set(page);
    this.pageSubName.set(pageSubName);
    if (page !== "CORE_LOGIN") {
      const { status, code } = await apiCallLogAdminSubTabAccess({
        subTab: page
      });
      if (status !== "OK") {
        getCorePopUpStore().showAlertMessage(code);
      }
    }
  };
  getPageName = () => {
    return this.pageName.get();
  };
  getPageSubName = () => {
    return this.pageSubName.get();
  };

  openNewTab = (targetScreen: string) => {
    window.open(targetScreen, "_blank");
  };
}
const getCoreHistoryStore = memoize(
  () => new CoreHistoryStore(),
  () => 1
);
export default getCoreHistoryStore;
